<template>
  <div :class="s.contentLicenses">    
    <img :src="require('../../images/license5.png')" />
    <br/>
    <img :src="require('../../images/promission2.jpeg')"/>
    <br/>
    <img :src="require('../../images/ic_license_sys.jpg')"/>
  </div>
</template>

<script>
export default {
  name: 'ContentLicenses',
  computed: {
    s() {
      return this.$style;
    }
  }
};
</script>

<style scoped lang="less" module>
.contentLicenses {
  font-size: 15px;
  line-height: 30px;
  text-indent: 2em;

  img {
    max-width: 70%;
    object-fit: cover;
  }
}
</style>
